import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import ReceivingShipmentInformation from './components/show/ReceivingShipmentInformation';
import DevicesInformation from './components/show/DevicesInformation';
import ShowContainer from '../../shared/components/show/ShowContainer';

const ReceivingShipmentsShow = () => (
  <Container>
    <ShowContainer>
      {
        (resourceitem) => {
          if (Object.keys(resourceitem).length === 0) return null;
          return (
            <Container>
              <ReceivingShipmentInformation resourceitem={resourceitem} />
              {
                resourceitem.itemType === 'serial_number'
                && <hr />
              }
              {
                resourceitem.itemType === 'serial_number'
                && <DevicesInformation resourceitem={resourceitem} />
              }
            </Container>
          );
        }
      }
    </ShowContainer>
  </Container>
);

export default withRouter(connect()(ReceivingShipmentsShow));
